(function () {
  'use strict';

  if (window.__NR_RADIO_NAV__) return;
  window.__NR_RADIO_NAV__ = true;

  if (document.documentElement.classList.contains('shopify-design-mode')) return;

  var MAIN_SELECTOR = '#MainContent';
  var COMPLEX_PATH_RE = /^\/(collections|blogs|products|search)\b/i;
  var EXCLUDED_PATH_RE = /^\/(cart|checkout|account|apps|admin|challenge)\b/i;

  function isComplexPath(pathname) {
    return COMPLEX_PATH_RE.test(pathname || '');
  }

  function isExcludedPath(pathname) {
    return EXCLUDED_PATH_RE.test(pathname || '');
  }

  function isComplexToComplex(fromPath, toPath) {
    if (isComplexPath(fromPath) && isComplexPath(toPath)) return true;
    if (fromPath.indexOf('/blogs/') === 0 && toPath.indexOf('/blogs/') === 0) return true;
    if (fromPath.indexOf('/collections/') === 0 && toPath.indexOf('/collections/') === 0) return true;
    return false;
  }

  function shouldHandleLink(link, event) {
    if (!link || link.tagName !== 'A') return false;
    if (event.defaultPrevented) return false;
    if (event.button !== 0) return false;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (link.target && link.target !== '_self') return false;
    if (link.hasAttribute('download')) return false;
    if (link.getAttribute('href') == null) return false;
    if (link.dataset.nrRadioNav === 'off') return false;

    var href = link.getAttribute('href');
    if (!href || href.charAt(0) === '#') return false;
    if (/^(mailto:|tel:|javascript:)/i.test(href)) return false;

    var url;
    try {
      url = new URL(link.href, window.location.origin);
    } catch (e) {
      return false;
    }

    if (url.origin !== window.location.origin) return false;
    if (isExcludedPath(url.pathname)) return false;

    var fromPath = window.location.pathname;
    var toPath = url.pathname;

    /* Never partial-nav into shop, archive, product, or search. */
    if (isComplexPath(toPath) || isExcludedPath(toPath)) return false;

    /* Pagination, filters, tags — stay on full page loads within shop/archive. */
    if (isComplexToComplex(fromPath, toPath)) return false;

    /* Leaving shop/archive for a simple page — partial nav keeps audio seamless. */
    return true;
  }

  function extractMainHtml(htmlText) {
    var doc = new DOMParser().parseFromString(htmlText, 'text/html');
    var nextMain = doc.querySelector(MAIN_SELECTOR);
    if (!nextMain) return null;

    return {
      mainHtml: nextMain.innerHTML,
      title: doc.title || document.title,
      bodyClass: doc.body ? doc.body.className : '',
    };
  }

  function syncBodyClass(bodyClass) {
    if (!bodyClass) return;
    document.body.className = bodyClass;
  }

  function runScripts(container) {
    container.querySelectorAll('script').forEach(function (oldScript) {
      var script = document.createElement('script');
      for (var i = 0; i < oldScript.attributes.length; i++) {
        var attr = oldScript.attributes[i];
        script.setAttribute(attr.name, attr.value);
      }
      script.textContent = oldScript.textContent;
      oldScript.replaceWith(script);
    });
  }

  function scrollToTop() {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }

  function saveRadioState() {
    if (window.NRRadio && typeof window.NRRadio.onPageHide === 'function') {
      window.NRRadio.onPageHide();
    }
  }

  function closeOpenMenus() {
    document.querySelectorAll('header-drawer').forEach(function (drawer) {
      if (drawer.isOpen && typeof drawer.close === 'function') {
        drawer.close();
      }
    });

    document.querySelectorAll('details.menu-open, details[open]#Details-menu-drawer-container').forEach(function (details) {
      details.classList.remove('menu-open');
      details.removeAttribute('open');
      var summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    });

    document.documentElement.removeAttribute('scroll-lock');
  }

  var navigating = false;

  async function visit(url, pushState) {
    if (navigating) return;

    var target;
    try {
      target = new URL(url, window.location.origin);
    } catch (e) {
      window.location.assign(url);
      return;
    }

    if (isComplexPath(target.pathname) || isExcludedPath(target.pathname)) {
      window.location.assign(url);
      return;
    }

    navigating = true;

    try {
      var response = await fetch(url, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'NR-Radio-Nav' },
      });

      if (!response.ok) {
        window.location.assign(url);
        return;
      }

      var htmlText = await response.text();
      var page = extractMainHtml(htmlText);
      if (!page) {
        window.location.assign(url);
        return;
      }

      var main = document.querySelector(MAIN_SELECTOR);
      if (!main) {
        window.location.assign(url);
        return;
      }

      main.innerHTML = page.mainHtml;
      document.title = page.title;
      syncBodyClass(page.bodyClass);
      runScripts(main);
      scrollToTop();

      if (pushState) {
        history.pushState({ nrRadioNav: true }, '', url);
      }

      document.dispatchEvent(new CustomEvent('nr:page:load', { detail: { url: url } }));

      if (window.NRRadio) {
        window.NRRadio.syncUi();
      }

      closeOpenMenus();
    } catch (e) {
      window.location.assign(url);
    } finally {
      navigating = false;
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a');
    if (!shouldHandleLink(link, event)) return;

    event.preventDefault();
    closeOpenMenus();
    saveRadioState();
    visit(link.href, true);
  });

  window.addEventListener('popstate', function (event) {
    if (event.state && event.state.nrRadioNav) {
      visit(window.location.href, false);
      return;
    }

    window.location.reload();
  });
})();
